import React from 'react';
import DefaultLayout from '../DefaultLayout';
import ProductDrawer from './drawer';

interface IProps {
  main?: React.ReactNode;
}

export default function ProductLayout(props: IProps) {
  const { main } = props;

  return <DefaultLayout drawer={<ProductDrawer />} main={main} />;
}
